<script lang="ts">
  import { cn } from "@tastyworks/ui-library"

  let cssClass: string | undefined | null = undefined
  export { cssClass as class }

  type Alignment = "start" | "center" | "end"
  export let alignActions: Alignment = "end"
</script>

<div
  class={cn("mobile:flex-col-reverse gap-extra-small flex w-full", cssClass)}
  class:justify-start={alignActions === "start"}
  class:justify-center={alignActions === "center"}
  class:justify-end={alignActions === "end"}
>
  <slot />
</div>
